import { GREAT_WHITE } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4, H7 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error dependency missing types
import PROMO_CARD_IMAGE from 'bender-url!../../img/marketing-plus/marketing-plus-promo-card.png';
import { getMarketingPlusUrl } from 'pricing-pages-lib/utils/urls';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { LOCATIONS } from '../../constants/tracking/Locations';
import { getButtonClickEvent } from '../../utils/event-tracking/interactions';
import { trackEvent } from '../../utils/event-tracking/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardWrapper = styled(UICardWrapper).withConfig({
  displayName: "MarketingPlusPromoCard__CardWrapper",
  componentId: "sc-1g2z7t8-0"
})(["border:1px solid ", ";box-shadow:none;"], GREAT_WHITE);
const CardHeader = styled(H7).withConfig({
  displayName: "MarketingPlusPromoCard__CardHeader",
  componentId: "sc-1g2z7t8-1"
})(["font-weight:500;"]);
const Content = styled.div.withConfig({
  displayName: "MarketingPlusPromoCard__Content",
  componentId: "sc-1g2z7t8-2"
})(["max-width:75ch;"]);
const MarketingPlusPromoCard = () => {
  const history = useHistory();
  const handleClick = () => {
    trackEvent(getButtonClickEvent({
      value: I18n.text('pricingPage.promoCards.marketing-plus.cta', {
        locale: 'en-us'
      }),
      location: LOCATIONS.MARKETING_PLUS_CARD
    }));
    history.push(getMarketingPlusUrl());
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    use: "island",
    children: /*#__PURE__*/_jsx(UICardSection, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        justify: "between",
        align: "center",
        children: [/*#__PURE__*/_jsxs(Content, {
          children: [/*#__PURE__*/_jsx(CardHeader, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.promoCards.marketing-plus.title"
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "m-top-10",
            children: [/*#__PURE__*/_jsx(H4, {
              "aria-level": 3,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.pages.products.tabs.marketing-plus.pageTitle"
              })
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.promoCards.marketing-plus.description"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "m-top-10",
            children: /*#__PURE__*/_jsx(UIButton, {
              use: "tertiary",
              onClick: handleClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.promoCards.marketing-plus.cta"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(UIImage, {
          src: PROMO_CARD_IMAGE,
          width: "268px",
          objectFit: "contain"
        })]
      })
    })
  });
};
export default MarketingPlusPromoCard;